
















































import { Component, Prop, Vue } from "vue-property-decorator";
import Inputseartch from "@/components/app/search/input-search.vue";
import { IRoom, IRoomControl } from "@/@types/hotel/room";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import StandartModal from "@/components/app/standart-modal.vue";

interface IRoomLeavel {
  [x: string]: Array<Array<string>>;
}

@Component({
  components: { StandartModal, "input-search": Inputseartch },
})
export default class RoomDd extends Vue {
  @Prop({ type: String, default: "" }) cabin!: string;
  @Prop({ type: Array, default: () => [] }) rooms!: Array<IRoom>;
  @Prop({ type: Array, default: () => [] }) roomLevels!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) roomTypes!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) roomStatuses!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) virtualRooms!: Array<IVirtualRooma>;
  search = "";
  width = 2;
  waif: Array<IRoom> = [];

  get roomNumber(): string {
    const room = this.rooms.find((el) => el._id == this.cabin);
    return room
      ? room.name
      : String(
          this.$t("Guests.Add.form.roomNumber.dd", {
            cabin: this.$t("change.add-room"),
          })
        );
  }

  get roomList(): IRoomLeavel {
    const levels: IRoomLeavel = {};
    this.waif = [];
    const levels_id: Array<string> = [];
    this.roomLevels.forEach((el) => levels_id.push(el._id));

    const maximus: { [x: string]: { x: string; y: string } } = {};
    let maxx = 0;
    this.rooms.forEach((el) => {
      if (
        el.level &&
        el.position &&
        el.position.x !== null &&
        el.position.x !== undefined &&
        el.position.y !== null &&
        el.position.y !== undefined &&
        levels_id.includes(el.level)
      ) {
        const x =
          maximus[el.level] && maximus[el.level].x
            ? parseInt(maximus[el.level].x) < parseInt(el.position.x)
              ? el.position.x
              : maximus[el.level]?.x
            : String(0);
        const y =
          maximus[el.level] && maximus[el.level].y
            ? parseInt(maximus[el.level].y) < parseInt(el.position.y)
              ? el.position.y
              : maximus[el.level]?.y
            : String(0);
        maximus[el.level] = { x, y };

        maxx = maxx < parseInt(x) ? parseInt(x) : maxx;
      }
    });

    this.width = 100 / (maxx + 1) > 6 ? 6 : 100 / (maxx + 1);
    if (!Object.keys(maximus).length) return levels;

    this.roomLevels.forEach((el) => {
      const y = maximus[el._id] ? parseInt(maximus[el._id].y) : 0;
      const x = maximus[el._id] ? parseInt(maximus[el._id].x) + 1 : 0;

      this.roomLevels.forEach((el) => levels_id.push(el._id));
      levels[el._id] = new Array(y ? y + 1 : 0);
      for (let i = 0; i < levels[el._id].length; i++) {
        this.$set(levels[el._id], i, new Array(x ? x : 0).join("*").split(""));
      }
    });

    this.rooms.forEach((el) => {
      if (
        !el.level ||
        !el.position ||
        el.position.x === null ||
        el.position.x === undefined ||
        el.position.y === null ||
        el.position.y === undefined ||
        !levels_id.includes(el.level)
      )
        this.waif.push(el);
      else {
        const x = parseInt(el.position.x);
        const y = parseInt(el.position.y);

        let j = 0;
        while (!levels[el.level][y]) {
          if (j > 5) {
            break;
          }
          j++;
          levels[el.level].push([]);
        }

        let i = 0;
        while (!levels[el.level][y][x]) {
          if (i > 250) {
            break;
          }
          i++;
          levels[el.level][y].push("*");
        }
        levels[el.level][y][x] = JSON.parse(JSON.stringify(el._id));
      }
    });
    return levels;
  }

  room_bg(room_id: string): string {
    const vrooma = this.virtualRooms.find((vr) => vr.room == room_id);
    return vrooma ? "red-lighten" : "teal-lighten";
  }

  getLevelName(id: string): Array<IRoom> {
    const level = this.roomLevels.find((el) => el._id == id);
    return level ? this.$getLocale(level.name) : "-";
  }

  getType(type: string): string {
    const t = this.roomTypes.find((el) => el._id == type);
    if (t) return this.$getLocale(t.name);
    return type ? `<code>${type}</code>` : "";
  }

  getRoomStatus(type: string): string {
    const t = this.roomStatuses.find((el) => el._id == type);
    if (t) return this.$getLocale(t.name);
    return type ? `<code>${type}</code>` : "";
  }

  getRoom(room_id: string): Partial<IRoom> {
    const room = this.rooms.find((el) => el._id == room_id);
    return room ? room : { _id: room_id };
  }
}
